import { Handlebars, AppController, _ } from "./imports"
import { registerSW } from 'virtual:pwa-register'

const flashClasses = {
    notice: "alert-info",
    success: "alert-success",
    warn: "alert-warning",
    alert: "alert-danger",
    error: "alert-danger"
}
const flashTitles : object = {
    notice: "Info",
    success: "Success",
    warn: "Warning",
    alert: "Error",
    error: "Error"
}

export default class OrsyXPController extends AppController{
    
    static targets: string[] = ["alertContainer", "alertTemplate", "flashAlert", 
        "dialogElm",
        "promptDialog", "promptDialogForm", "promptDialogText",
        "confirmDialog", "confirmDialogForm", "confirmDialogText",
        "alertDialog", "alertDialogText",
        "adminCompanySelectForm", "adminCompanySelect",
        "toggleNavBtn", "sidebarElm"
    ] //"offlineModeText"

    
    declare readonly alertContainerTarget : HTMLElement
    declare readonly alertTemplateTarget : HTMLTemplateElement
    declare readonly flashAlertTargets : HTMLElement[]
    declare readonly alertTemplate : HandlebarsTemplateDelegate
    declare readonly dialogElmTargets : HTMLElement[]
    declare readonly promptDialogTarget : HTMLDialogElement
    declare readonly promptDialogFormTarget : HTMLFormElement
    declare readonly promptDialogTextTarget : HTMLElement
    declare readonly confirmDialogTarget : HTMLDialogElement
    declare readonly confirmDialogFormTarget : HTMLFormElement
    declare readonly confirmDialogTextTarget : HTMLElement
    declare readonly alertDialogTarget : HTMLDialogElement
    declare readonly alertDialogTextTarget : HTMLElement
    declare readonly adminCompanySelectFormTarget : HTMLFormElement
    declare readonly adminCompanySelectTarget : HTMLSelectElement
    declare readonly toggleNavBtnTarget : HTMLElement
    declare readonly sidebarElmTarget : HTMLElement

    periodSyncTime = 5000
    swActive = false
    isOnline = true
    refreshSW?: ((reloadPage?: boolean) => Promise<void> | undefined) = undefined

    initialize(): void {
        this.isOnline = navigator.onLine
        //this.onlineStatusSync()
        // todo: service workers?
        // this.refreshSW = registerSW({
        //     immediate: true,
        //     onOfflineReady: () => {
                
        //         console.log("App ready for offline")
        //     },
        //     onNeedRefresh: () => {
        //         console.log("page needs refresh")
        //         //window.location.reload()
        //     },
        //     onRegisteredSW: (swUrl, r) =>{
        //         console.log("SW Registered")
        //         if (this.periodSyncTime <= 0) {return}
        //         if (r?.active?.state === "activated"){
        //             this.swActive = true
        //             this.registerSync(this.periodSyncTime, swUrl, r)
        //         }else if (r?.installing){
        //             r.installing.addEventListener("stagechange", (ev : Event) => {
        //                 console.log("state changed")
        //                 var sw = ev.target as ServiceWorker
        //                 this.swActive = (sw.state === "activated")
        //                 if (this.swActive){
        //                     this.registerSync(this.periodSyncTime, swUrl, r)
        //                 }
        //             })
        //         }

        //     }
        // })
    }


    connect(): void {
        globalThis.orsyXP = this
        globalThis._ = _
        String.prototype.toHTML = this.stringToHTML
        this.compileTemplates(this.alertTemplateTarget)
        globalThis.flashInfo = this.flashInfo.bind(this)
        globalThis.flashSuccess = this.flashSuccess.bind(this)
        globalThis.flashWarn = this.flashWarn.bind(this)
        globalThis.flashError = this.flashError.bind(this)
        globalThis.flashClearAll = this.flashClearAll.bind(this)
        globalThis.orsyXPPrompt = this.prompt.bind(this)
        globalThis.orsyXPConfirm = this.confirm.bind(this)
        globalThis.orsyXPAlert = this.alert.bind(this)
        globalThis.orsyXPDialogCloseAll = this.closeAllDialogs.bind(this)

        
    }

    changeCompany(ev){
        this.adminCompanySelectFormTarget.submit()
    }

    registerSync(periodSyncTime : number, swUrl : string, r: ServiceWorkerRegistration){
        console.log("register?")
        if (periodSyncTime <= 0) return
        setInterval(async () => {
            console.log("test if offline")
            if (r.installing || !navigator){return} // docs dont explain.
            //if (this.isOnline != navigator.onLine){this.onlineStatusSync()}
            this.isOnline = navigator.onLine
            if (!this.isOnline){return}
            var res = await fetch(swUrl, {
                cache: "no-store", headers: {'cache': 'no-store','cache-control': 'no-cache'}
            })
            if (res?.status === 200){
                await r.update()
            }
        }, periodSyncTime)
    }

    // onlineStatusSync(){
    //     if (navigator.onLine){
    //         this.offlineModeTextTarget.classList.add("d-none")
    //     }else{
    //         this.offlineModeTextTarget.classList.remove("d-none")
    //     }
    // }

    flashAlertTargetConnected(elm){
        setTimeout(this.flashClear.bind(this, elm), 15000)
    }

    // to be added to the string object, converts an string containing html to node objects
    stringToHTML(this : String) : Node{
        var doc = document.createElement('template')
        doc.innerHTML = this.trim()
        return doc.content.firstChild
    }

    templateResToHTML(templateRes : String) : Node{
        var doc = document.createElement('template')
        doc.innerHTML = templateRes.trim()
        return doc.content.firstChild
    }


    flashInfo(message : string, title=null) : void {
        this.flash("info", message, title)
    }

    flashSuccess(message : string, title=null) : void {
        this.flash("success", message, title)
    }

    flashWarn(message : string, title=null) : void {
        this.flash("warn", message, title)
    }

    flashError(message : string, title=null) : void {
        this.flash("error", message, title)
    }

    flash(type : string, message : string, title=null, timeout=15){
        this.flashClearAll()
        var alert = this.alertTemplate({
            alertType: flashClasses[type] ?? "alert-warning",
            alertTitle: (title == null) ? flashTitles[type] ?? "Warning" : title,
            alertMessage: message
        })
        var flashElm = this.alertContainerTarget.appendChild(alert.toHTML())
        setTimeout(this.flashClear.bind(this, flashElm), timeout * 1000)
        if (this.alertContainerTarget.children.length > 5){ // avoid creating hundreds of alerts
            this.alertContainerTarget.removeChild(this.alertContainerTarget.firstElementChild)
        }
    }

    flashClearAll(){
        this.alertContainerTarget.replaceChildren()
    }

    flashClear(elm : HTMLElement){
        elm.replaceWith()
    }

    closeAllDialogs(){
        this.dialogElmTargets.forEach((elm : HTMLDialogElement) => {
            if (elm.open){
                elm.classList.remove("open")
                elm.close()
            }
        })
    }

    checkTurboStatus(ev){
        var resp = ev.detail.fetchResponse.response.clone()
        if (!_.includes([403,404,422,406,500], resp.status)){return}
        resp.json().then((jres) => {
            if (!_.isNil(jres.error)){
                this.flashError(`${resp.status}: ${jres.error}`)
            }else{
                this.flashError(`Server responded with ${resp.status}`)
            }
        }).catch((err) => {
            this.flashError(`Server responded with ${resp.status}`)
        })
    }

    prompt(message : string) : Promise<string> {
        this.closeAllDialogs()
        this.promptDialogTextTarget.innerText = message
        this.promptDialogFormTarget.reset()
        this.promptDialogTarget.showModal()
        this.promptDialogTarget.classList.add("open")
        return new Promise<string>((resolve, reject) => {
            this.registerDialogClose(this.promptDialogTarget, (returnValue) => {
                if (returnValue === "submit"){
                    resolve(this.promptDialogFormTarget.promptDialogInput.value)
                }
            })
            
        })
    }


    dialogElmTargetConnected(elm : HTMLDialogElement){
        // automatically bind value to returnValue, as IMO it should do this by default https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/returnValue
        elm.querySelectorAll("button").forEach((btnElm) => {
            btnElm.addEventListener("click", (ev) => {
                elm.close(btnElm.value)
            })
        })
    }

    

    confirm(message : string, returnDeny = false) : Promise<boolean>{
        this.closeAllDialogs()
        this.confirmDialogTextTarget.innerText = message
        this.confirmDialogTarget.showModal()
        this.confirmDialogTarget.classList.add("open")
        return new Promise<boolean>((resolve, reject) => {
            this.registerDialogClose(this.confirmDialogTarget, (returnValue) => {
                if (returnDeny){
                    resolve(returnValue === "submit")
                }else if(returnValue === "submit") {
                    resolve(true)
                }
                
            })
        })
    }
    
    alert(message : string){
        this.closeAllDialogs()
        this.alertDialogTextTarget.innerText = message
        this.alertDialogTarget.showModal()
        this.alertDialogTarget.classList.add("open")
        return new Promise((resolve, reject) => {
            this.registerDialogClose(this.alertDialogTarget, (returnValue) => {
                resolve(null)
            })
        })
    }
    

    registerDialogClose(dialogElm : HTMLDialogElement, callback : (returnValue : string) => void) {
        // finishes the web standard to include all the needed aspects of a dialog, i.e. enter key
        var dialogCloseListener = (ev) => {
            if(ev.key === "Enter"){
                ev.preventDefault()
                dialogElm.close("submit")
            }
        }
        document.addEventListener("keydown", dialogCloseListener)
        dialogElm.addEventListener("close", (ev) => {
            document.removeEventListener("keydown", dialogCloseListener) // unregister event no matter what
            dialogElm.classList.remove("open")
            callback(dialogElm.returnValue)
        }, {once: true})

    }

    toggleNav(ev){
        if (!this.sidebarElmTarget.classList.contains("show")){
            this.toggleNavBtnTarget.ariaExpanded = "true"
            this.sidebarElmTarget.classList.add("show")
        }else{
            this.toggleNavBtnTarget.ariaExpanded = "false"
            this.sidebarElmTarget.classList.remove("show")
        }
        
    }
    
    

    

    

}